import React from "react";

import {
  Class,
  JSTypeOperator,
  ObjectTypes,
} from "../../../../GenericCoreGraph/ClassFramework/Class";
import LessonDetailModalStyles from "../../../../../ScriptStyles/LessonDetailModalStyles";
import TObject from "../../../../TagComponents/TObject";
import Actions from "../../../../GenericWebController/ActionGraph/Actions";
import { CommandIDs } from "../../../../GenericWebController/CommandInterpreter/CommandIDs/CommandIDs";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import CreateIcon from "@material-ui/icons/Create";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import PersonIcon from "@material-ui/icons/Person";
import GroupIcon from "@material-ui/icons/Group";
import TBaseDialogModal from "../../../Utilities/TBaseDialogModal";
import DefaultTheme from "../../../../../Themes/DefaultTheme";

var TLessonDetailModal = Class(
  TBaseDialogModal,
  {
    ObjectType: ObjectTypes.Get("TLessonDetailModal"),
    constructor: function (_Props) {
      TLessonDetailModal.BaseObject.constructor.call(this, _Props);
      this.state = {
        ...this.state,
        open: false,
        lessonDetail: null,
        sellerDetail: null,
        subLessons: null,
        sellerDetailId: null,
        sellerLessons: null,
        bookingPermission: true,
      };
      window.App.LessonDetailModal = this;
    },
    Destroy: function () {
      TLessonDetailModal.BaseObject.Destroy.call(this);
    },
    HandleGetSubLessons: function (_SellerLessonId, _SellerDetailId) {
      var __This = this;
      Actions.GetSellerLessonBySellerLessonID(
        _SellerDetailId,
        _SellerLessonId,
        function (_Message) {
          CommandIDs.ResultItemCommand.RunIfHas(_Message, function (_Data) {
            __This.setState({
              subLessons: _Data.Item.LessonDetailIDList,
            });
          });
        }
      );
    },

    /*_SellerDetail,
      _Lesson,
      _SellerDetailId,
      _SellerLessons,
      _BookingPermission,
      _CallbackOnClose*/
    HandleClickOpen: function (_ParamObject, _CallbackOnClose) {
      TLessonDetailModal.BaseObject.HandleClickOpen.call(
        this,
        _ParamObject,
        _CallbackOnClose
      );
      this.CallbackOnClose = _CallbackOnClose;
      this.setState(
        {
          open: true,
          lessonDetail: _ParamObject.Lesson,
          sellerDetail: _ParamObject.SellerDetail,
          sellerDetailId: _ParamObject.SellerDetailId,
          sellerLessons: _ParamObject.SellerLessons,
          bookingPermission: _ParamObject.BookingPermission,
        },
        () => {
          this.HandleGetSubLessons(
            this.state.lessonDetail.ID,
            this.state.sellerDetailId
          );
        }
      );
    },
    HandleClose: function () {
      this.setState({
        open: false,
      });
      if (JSTypeOperator.IsFunction(this.CallbackOnClose)) {
        var __Function = this.CallbackOnClose;
        this.CallbackOnClose = null;
        __Function();
      }
    },
    HandleOnChange: function (event, _Name) {
      if (_Name) {
        this.setState({ [_Name]: event.target.value });
      } else {
        this.setState({ [event.target.name]: event.target.value });
      }
    },
    HandleOpenLessonBookingModal: function (_Lesson) {
      var __This = this;
      __This.setState({ open: false });
      window.App.LoginPageModal.HandleClickOpen(null, function (_isLogined) {
        if (_isLogined) {
          if (window.App.User.FreeLessonUse < window.App.GlobalParams.MaxFreeLessonUse || _Lesson.Credit > 0) {
            window.App.SelectAndBuyLessonModal.HandleClickOpen({
              SellerLessons: __This.state.sellerLessons,
              SellerDetailId: __This.state.sellerDetailId,
              UserSellerDetail: __This.state.sellerDetail,
              SelectedLesson: _Lesson,
              OpenType: 0,
            });
          } else {
            window.App.MessageBox.ShowMessage(
              __This.state.Language.Warning,
              __This.state.Language.FreeLessonUse,
              "danger",
              true
            );
          }
        }
      });
    },
    HandleGetLessonHeader: function (_Lesson) {
      return (
        <div>
          <Typography
            variant="button"
            display="block"
            gutterBottom
            style={{ textDecoration: "none" }}
          >
            {_Lesson.LessonHeader}
          </Typography>
          <Typography
            variant="body2"
            display="block"
            gutterBottom
            style={{ textDecoration: "none" }}
          >
            {this.state.Language[_Lesson.LessonCode]}
          </Typography>
        </div>
      );
    },
    HandleGetLessonDetail: function () {
      var __This = this;
      return (
        __This.state.subLessons &&
        __This.state.subLessons.map((subLesson) => {
          return (
            <Typography
              variant="body2"
              display="block"
              gutterBottom
              style={{ textDecoration: "none" }}
            >
              {this.state.Language[subLesson.Code]}
            </Typography>
          );
        })
      );
    },

    HandleGetTime: function (_Lesson) {
      return (
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={4}>
            <Typography
              variant="button"
              display="block"
              gutterBottom
              style={{ textDecoration: "none" }}
            >
              {this.state.Language.LessonDetail}
            </Typography>
            {this.HandleGetLessonDetail()}
          </Grid>
          <Grid
            item
            xs={1}
            justifyContent="center"
            alignItems="center"
            style={{ height: "80px" }}
          >
            <Divider orientation="vertical" style={{ margin: "auto" }} />
          </Grid>
          <Grid item xs={3}>
            <Typography
              variant="body2"
              display="block"
              gutterBottom
              style={{ textDecoration: "none" }}
            >
              {_Lesson.Credit != 0
                ? _Lesson.Credit + " " + this.state.Language.Credit
                : this.state.Language.FreeLesson}
            </Typography>
            {_Lesson.Credit != 0 ? (
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "left",
                  float: "right",
                  width: "100%",
                }}
              >
                <React.Fragment>
                  <div
                    style={{
                      fontWeight: 600,
                      color: "#D23F57",
                    }}
                  >
                    {window.App.User == null
                      ? (
                          _Lesson.Credit *
                          window.App.GlobalParams.PerCreditCostTL
                        ).toFixed(2) + " ₺"
                      : (
                          _Lesson.Credit * window.App.User.PerCreditCostTL
                        ).toFixed(2) + " ₺"}
                  </div>
                  {window.App.User != null &&
                  window.App.User.NoDiscountPerCreditCostTL !=
                    window.App.User.PerCreditCostTL ? (
                    <div
                      style={{
                        fontWeight: 600,
                        color: "#7D879C",
                      }}
                    >
                      <del>
                        {(
                          _Lesson.Credit *
                          window.App.User.NoDiscountPerCreditCostTL
                        ).toFixed(2) + " ₺"}
                      </del>
                    </div>
                  ) : null}
                  {window.App.User == null &&
                  window.App.GlobalParams.PerCreditCostTL !=
                    window.App.GlobalParams.NoDiscountPerCreditCostTL ? (
                    <div
                      style={{
                        fontWeight: 600,
                        color: "#7D879C",
                      }}
                    >
                      <del>
                        {(
                          _Lesson.Credit *
                          window.App.GlobalParams.NoDiscountPerCreditCostTL
                        ).toFixed(2) + " ₺"}
                      </del>
                    </div>
                  ) : null}
                </React.Fragment>
              </div>
            ) : null}
            <Typography
              variant="body2"
              display="block"
              gutterBottom
              style={{ textDecoration: "none" }}
            >
              {_Lesson.Credit != 0
                ? _Lesson.Minute + " " + this.state.Language.Minute
                : window.App.GlobalParams.FreeLessonMinute +
                  " " +
                  this.state.Language.Minute}
            </Typography>
          </Grid>
          <Grid
            item
            xs={1}
            justifyContent="center"
            alignItems="center"
            style={{ height: "80px" }}
          >
            <Divider orientation="vertical" style={{ margin: "auto" }} />
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" display="block" gutterBottom>
              {_Lesson.LessonType === 0 ? (
                <PersonIcon
                  fontSize="large"
                  style={{
                    marginRight: "10px",
                    color: DefaultTheme.palette.secondary.main,
                  }}
                />
              ) : (
                <GroupIcon
                  fontSize="large"
                  style={{
                    marginRight: "10px",
                    color: DefaultTheme.palette.action.main,
                  }}
                />
              )}
            </Typography>
            <Typography
              variant="body2"
              display="block"
              gutterBottom
              style={{ textDecoration: "none" }}
            >
              {_Lesson.LessonType === 0
                ? this.state.Language.Individual
                : this.state.Language.Class}
            </Typography>
          </Grid>
        </Grid>
      );
    },
    HandleGetLessonDefinition: function (_Lesson) {
      return (
        <Typography variant="body2" display="block" gutterBottom>
          <div
            style={{ textAlign: "left" }}
            dangerouslySetInnerHTML={{
              __html: _Lesson.CustomLessonText,
            }}
          />
        </Typography>
      );
    },

    HandleGetBookingPermission: function (_Lesson) {
      var __This = this;
      const { classes } = this.props;
      if (__This.state.bookingPermission) {
        return (
          <div style={{ padding: "15px" }}>
            <Button
              fullWidth={true}
              startIcon={<CreateIcon />}
              autoFocus
              variant="contained"
              color="primary"
              onClick={() => this.HandleOpenLessonBookingModal(_Lesson)}
              className={classes.gridBorder}
            >
              {__This.state.Language.LessonBookNow}
            </Button>
          </div>
        );
      } else {
        return null;
      }
    },
    HandleGetSize: function () {
      return "sm";
    },
    render: function () {
      var __This = this;
      var __Lesson = this.state.lessonDetail;
      const { classes } = this.props;
      var __Params = TLessonDetailModal.BaseObject.render.call(this);
      if (!__Params.NeedRender) {
        return null;
      }
      return this.HandleWrapModal(
        <div>
          <DialogTitle>
            {this.state.Language.LessonDetailModalHeader}
          </DialogTitle>
          {__Lesson && (
            <DialogContent dividers>
              <div className={classNames("animated fadeIn")}>
                {this.HandleGetLessonHeader(__Lesson)}
              </div>
              <Divider
                light
                style={{ marginTop: "10px", marginBottom: "10px" }}
              />
              <div className={classNames("animated fadeIn")}>
                {this.HandleGetTime(__Lesson)}
              </div>
              <Divider
                light
                style={{ marginTop: "10px", marginBottom: "10px" }}
              />
              <div className={classNames("animated fadeIn")}>
                <Typography variant="button" display="block" gutterBottom>
                  {this.state.Language.SellerLessonDefinition}
                </Typography>
                {this.HandleGetLessonDefinition(__Lesson)}
              </div>
            </DialogContent>
          )}
          {__This.HandleGetBookingPermission(__Lesson)}
        </div>
      );
    },
  },
  {}
);

export default withStyles(LessonDetailModalStyles)(TLessonDetailModal);
